export default __webpack_public_path__ + "static/media/icon-especie.abe673d5.svg";